
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DateTime } from "luxon";
import { Game, GameCSV } from "@/models/Game";
import GameStatus from "../Base/GameStatus.vue";
import DialogGameDetails from "../Base/DialogGameDetails.vue";
import CreateGame from "../Compose/ComposeTabs/ComposeAdd/CreateGame.vue";
import DateHelper from "@/utils/DateHelper";
import { sortBy } from "lodash";
import { City } from "@/models/City";

@Component({
  components: { GameStatus, CreateGame, DialogGameDetails },
})
class GamesTable extends Vue {
  @Prop({ default: false }) readonly compose!: boolean;
  @Prop({ default: false }) readonly showCreateGame!: boolean;
  @Prop({ default: false }) readonly isDateLimited!: boolean;
  items = [];
  countArray: any[] = [];
  searchFilter = {
    name: "",
    showTemplate: true,
    showEvergreenInstance: true,
  };
  busy = true;
  showGame = false;
  gameData = {} as Game;
  showDialog = false;
  fields = [
    {
      key: "key",
      thClass: "d-none",
      tdClass: "d-none",
    },
    {
      key: "template",
      thClass: "d-none",
      tdClass: "d-none",
    },
    {
      key: "evergreen_isClone",
      thClass: "d-none",
      tdClass: "d-none",
    },
    {
      key: "admin_name",
      label: "Name",
      sortable: true,
    },
    {
      key: "start_dt",
      label: "Start Date (Browser local)",
      sortByFormatted: true,
      sortable: true,
      formatter: (value: string) => {
        // * Get the time in a readable format
        return DateTime.fromISO(value)
          .toLocal()
          .toFormat("yyyy/MM/dd HH:mm ZZ");
      },
    },
    {
      key: "team_count",
      label: "#Teams (Active)",
      sortable: true,
    },
    {
      key: "status",
      label: "Status",
      sortable: true,
    },
    {
      key: "info",
      label: "Info",
      sortable: true,
    },
  ];
  get getGames(): Game[] {
    if (this.isDateLimited) {
      let startDate = DateHelper.getDatesInUTC(10);
      let endDate = DateHelper.getDatesInUTC(-10);
      return sortBy(
        this.$store.state.gameStore.games.filter((items: Game) => {
          return (
            (new Date(items.start_dt) > new Date(startDate) &&
              new Date(items.end_dt) < new Date(endDate)) ||
            items.live ||
            items.template ||
            items.evergreen?.isClone
          );
        }),
        "admin_name"
      );
    } else {
      return sortBy(this.$store.state.gameStore.games, "admin_name");
    }
  }
  get getCities(): City[] {
    return this.$store.state.cityStore.city;
  }

  get getTemplateCount(): number {
    return this.countArray
      .filter((value, index, array) => array.indexOf(value) === index)
      .filter((x) => x.template).length;
  }
  get getEvergreenCount(): number {
    return this.countArray
      .filter((value, index, array) => array.indexOf(value) === index)
      .filter((x) => x.evergreen !== undefined && x.evergreen.isClone).length;
  }
  getEvergreenClone(row: any): boolean {
    if (row === undefined) {
      return false;
    }
    return row.isClone;
  }
  getAdminName(row: any): string {
    if (
      row.evergreen !== undefined &&
      (row.evergreen.isClone || row.evergreen.isActive)
    ) {
      return "\u{1F332}" + row.admin_name;
    } else {
      return row.admin_name;
    }
  }
  get getGameExported(): GameCSV[] {
    var now = new Date();
    var gameCSV: GameCSV[] = [];
    var currentDate = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    var gameData = this.getGames.filter(
      (x) =>
        x.template == false &&
        x.publish_ready === true &&
        new Date(x.end_dt).toISOString() > currentDate
    );

    gameData.forEach((x: Game) => {
      gameCSV.push({
        admin_name: x.admin_name,
        gt_uid: x.gt_uid,
        city: x.city,
        start_dt: x.start_dt,
        end_dt: x.end_dt,
        univ_voucher: x.univ_voucher,
        v_count: x.v_count,
        v_used: x.v_used,
        startLat: this.getCities.filter((c: City) => c.slug == x.city)[0]
          .centre_point.latitude,
        startLng: this.getCities.filter((c: City) => c.slug == x.city)[0]
          .centre_point.longitude,
      });
    });

    return gameCSV;
  }

  /*get clonedRow(): string {
    return this.$store.state.gameStore.clonedRow;
  }*/

  created(): void {
    if (this.getGames.length > 0) {
      this.busy = false;
    }
    if (this.compose) {
      this.searchFilter = {
        name: "",
        showTemplate: true,
        showEvergreenInstance: true,
      };
    } else {
      this.searchFilter = {
        name: "",
        showTemplate: false,
        showEvergreenInstance: true,
      };
    }
  }

  get getPreAppLaunch(): number {
    return this.$store.state.authenication.appPrelaunch._value;
  }
  closeDialog(): void {
    this.showGame = false;
  }
  onRowSelected(rows: any): void {
    if (rows.length < 1) return;
    this.$emit("handleGameSelection", rows[0]);
  }
  filterByAdminName(row: any): boolean {
    var isEvergreen = false;
    if (row.evergreen !== undefined) {
      isEvergreen = row.evergreen.isClone;
    }
    if (
      this.searchFilter.name.length === 0 &&
      this.searchFilter.showTemplate &&
      this.searchFilter.showEvergreenInstance
    ) {
      this.countArray.push(row);
      return true;
    } else {
      if (this.searchFilter.name.length === 0) {
        if (
          this.searchFilter.showTemplate &&
          !this.searchFilter.showEvergreenInstance
        ) {
          if (isEvergreen) {
            return false;
          } else {
            this.countArray.push(row);
            return true;
          }
        }
        if (
          !this.searchFilter.showTemplate &&
          this.searchFilter.showEvergreenInstance
        ) {
          if (row.template) {
            return false;
          } else {
            this.countArray.push(row);
            return true;
          }
        }
        if (
          !this.searchFilter.showTemplate &&
          !this.searchFilter.showEvergreenInstance
        ) {
          if (row.template) {
            return false;
          } else if (isEvergreen) {
            return false;
          } else {
            this.countArray.push(row);
            return true;
          }
        }
      } else {
        if (
          row.key
            .toLowerCase()
            .includes(this.searchFilter.name.toLowerCase()) ||
          row.admin_name
            .toLowerCase()
            .includes(this.searchFilter.name.toLowerCase())
        ) {
          if (
            this.searchFilter.showTemplate &&
            this.searchFilter.showEvergreenInstance
          ) {
            this.countArray.push(row);
            return true;
          }
          if (
            this.searchFilter.showTemplate &&
            !this.searchFilter.showEvergreenInstance
          ) {
            if (isEvergreen) {
              return false;
            } else {
              this.countArray.push(row);
              return true;
            }
          }
          if (
            !this.searchFilter.showTemplate &&
            this.searchFilter.showEvergreenInstance
          ) {
            if (row.template) {
              return false;
            } else {
              this.countArray.push(row);
              return true;
            }
          }
          if (
            !this.searchFilter.showTemplate &&
            !this.searchFilter.showEvergreenInstance
          ) {
            if (row.template) {
              return false;
            } else if (isEvergreen) {
              return false;
            } else {
              this.countArray.push(row);
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  resetValues(): void {
    this.countArray = [];
  }
  openAddGame(): void {
    this.showGame = true;
  }

  openInfo(data: Game): void {
    this.gameData = data;
    this.$store.dispatch("cityStore/getSingleCity", this.gameData.city);
    this.showDialog = true;
  }
  closeGameDetailDialog(): void {
    this.showDialog = false;
  }

  exportToCSV(): void {
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += [
      Object.keys(this.getGameExported[0]).join(";"),
      ...this.getGameExported.map((item) => Object.values(item).join(";")),
    ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

    const data = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", "export.csv");
    link.click();
  }

  @Watch("getGames")
  isLoading(value: Game[]): void {
    if (value.length > 0) this.busy = false;
    else this.busy = false;
  }
}

export default GamesTable;
